import _extends from "@babel/runtime/helpers/extends";
import { Box } from '@wix/design-system';
import React from 'react';
import { dataHooks } from '../../../../../utils/datahooks';
import { HeadingStructureRuleGenericContent } from '../generic/heading-structure-rule-generic-content';
import { HeadingStructureRuleRegularContent } from '../regular/heading-structure-rule-regular-content';
export const HeadingStructureRuleContent = props => {
  const {
    isGeneric,
    pageId,
    onClickApply,
    onClickCancel,
    showLoader,
    dataHook,
    id,
    ...restProps
  } = props;
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHooks.headingStructureRuleContent(dataHook),
    direction: "vertical",
    gap: "SP2",
    marginTop: "SP1"
  }, isGeneric ? /*#__PURE__*/React.createElement(HeadingStructureRuleGenericContent, _extends({}, restProps, {
    id: id,
    pageId: pageId
  })) : /*#__PURE__*/React.createElement(HeadingStructureRuleRegularContent, _extends({}, restProps, {
    dataHook: dataHook,
    showLoader: showLoader,
    onClickApply: onClickApply,
    onClickCancel: onClickCancel
  })));
};
//# sourceMappingURL=heading-structure-rule-content.js.map